import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';
import { Project } from '../../types/model/project';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/project/projects`; 

/**
 * Obtém a lista de todos os projetos do backend.
 */
export const getProjects = async (): Promise<Project[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  return await axios
    .get<Project[]>(BASE_URL, {
      headers: {
        'content-type': 'application/json',
        'x-access-token': session?.accessToken,
      },
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== 'undefined'
          ? AbortSignal.timeout(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Erro ao buscar projetos:", error);
      return [];
    });
};
